export const supportedFileFormats = [
  ".aac",
  ".Amr",
  ".bmp",
  ".csv",
  ".doc",
  ".docx",
  ".Gif",
  ".jpeg",
  ".jpg",
  ".m3u",
  ".m4a",
  ".MOV",
  ".mp3",
  ".mp4",
  ".msg",
  ".msword",
  ".ogg",
  ".pdf",
  ".png",
  ".ppt",
  ".pptx",
  ".rar",
  ".tif",
  ".tiff",
  ".wav",
  ".xls",
  ".xlsx",
  ".xps",
  ".zip",
  ".txt"
];

export const apiUrl = "https://chatwave.simplify360.com";
export const languages = [
  { label: "English", value: "en" },
  { label: "Japanese", value: "ja" },
  { label: "Simplified Chinese", value: "zh" },
  { label: "Traditional Chinese", value: "zht" },
  { label: "Korean", value: "kr" },
  { label: "Tagalog", value: "tl" },
  { label: "Bahasa Indonesia", value: "id" },
  { label: "Vietnamese", value: "vi" },
  { label: "Thai", value: "th" },
  { label: "Malay", value: "ms" },
  { label: "Spanish", value: "es" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Italian", value: "it" },
  { label: "Portuguese", value: "pt" },
  { label: "Khmer", value: "km" },
  { label: "Hindi", value: "hd" },
  { label: "Bisaya", value: "ph bs" }
];
